import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const my: AppRouteModule = {
  path: '/space',
  name: 'space',
  component: LAYOUT,
  meta: {
    hideChildrenInMenu: true,
    orderNo: 4,
    icon: 'icon-faxian',
    title: '我的',
    activePaths: ['/space/*'],
  },
  children: [
    {
      path: '/space',
      name: 'MySpace',
      redirect: '/space/creations',
      component: () => import('/@/views/records/space/index.vue'),
      meta: {
        title: '我的空间',
      },
      children: [
        {
          path: 'creations',
          name: 'MyCreations',
          meta: {
            title: '我创作的',
            ignoreKeepAlive: false,
            hideMenu: true,
          },
          component: () => import('/@/views/records/creations/index.vue'),
        },
        {
          path: 'pins',
          name: 'MyPins',
          meta: {
            title: '我的灵感',
            ignoreKeepAlive: false,
            hideMenu: true,
          },
          component: () => import('/@/views/records/inspiration-set/index.vue'),
        },
        {
          path: 'pins/:dirIds+',
          name: 'MyPinDir',
          meta: {
            title: '我的灵感',
            ignoreKeepAlive: false,
            hideMenu: true,
          },
          props({ params }) {
            return {
              dirIds: params.dirIds,
            };
          },
          component: () => import('/@/views/records/inspiration-set/index.vue'),
        },
        {
          path: 'history',
          name: 'MyInspirationHistory',
          meta: {
            title: '灵感生成历史',
            ignoreKeepAlive: false,
            hideMenu: true,
          },
          component: () => import('/@/views/records/history/index.vue'),
        },
      ],
    },
    {
      path: '/mine',
      name: 'mine',
      meta: {
        title: '个人中心',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/mine/settings/index.vue'),
    },
    {
      path: '/member',
      name: 'Member',
      meta: {
        title: '成员管理',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/member/index.vue'),
    },
    {
      path: '/user',
      name: 'User',
      meta: {
        title: '个人信息管理',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/user/index.vue'),
    },
    {
      path: '/team',
      name: 'Team',
      meta: {
        title: '团队信息管理',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/team/index.vue'),
    },
    {
      path: '/account',
      name: 'Account',
      meta: {
        title: '账号管理',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/account/index.vue'),
    },
    {
      path: '/commerce',
      name: 'Commerce',
      meta: {
        title: '订单发票',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/commerce/index.vue'),
      children: [
        {
          path: 'order',
          name: 'Order',
          meta: {
            title: '订单',
            ignoreKeepAlive: false,
            hideMenu: true,
          },
          component: () => import('/@/views/commerce/order/index.vue'),
        },
        {
          path: 'invoice',
          name: 'Invoice',
          meta: {
            title: '发票',
            ignoreKeepAlive: false,
            hideMenu: true,
          },
          component: () => import('/@/views/commerce/invoice/index.vue'),
        },
      ],
    },
    {
      path: '/order/:tradeNo',
      name: 'OrderDetail',
      meta: {
        title: '订单详情',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/commerce/order-detail/index.vue'),
    },
    {
      path: '/invoice/:tradeNo',
      name: 'InvoiceDetail',
      meta: {
        title: '发票详情',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/commerce/invoice-detail/index.vue'),
    },
    {
      path: '/lingdou',
      name: 'Lingdou',
      meta: {
        title: '灵豆记录',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/commerce/lingdou/index.vue'),
    },
  ],
};

export default my;
